export default {
    newDesign: true,
    parameters: {
        landing_id: "PlQPsF",
        segment: 7,
    },
    title:
        "Tworzymy spersonalizowaną ścieżkę nauki dla Twojego dziecka | Kodland",
    downtimeUrl: "https://www.kodland.org/pl",
    startPage: {
        title:
            "Tworzymy spersonalizowaną ścieżkę nauki dla Twojego dziecka",
        subtitle:
            "Odpowiedz na kilka krótkich pytań: zaproponujemy najlepszy kurs i pokażemy, jakie umiejętności Twoje dziecko może rozwinąć.",
        // leftSide: {
        //     title: "Corso gratuito di creativita digitale o modellazione 3D per bambini/e e ragazzi/e",
        // },
        image: {
            url: "/welcome/pl_personalized_quiz_fwd_pc.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/pl_personalized_quiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Znajdź odpowiedni kurs 🚀",
    },
    stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
    quizRotateBySteps: {
        1: {
            title: "Ile lat ma Twoje dziecko?",
            type: "age",
            button: "",
        },
        2: {
            question:
                "Ile czasu Twoje dziecko spędza przed ekranem (telefon, komputer lub tablet)?",
            answers: [
                "🕐 Mniej niż 1 godzinę dziennie",
                "🕓 Od 1 do 4 godzin dziennie",
                "🕔 Więcej niż 4 godziny dziennie",
            ],
        },
        3: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
            subtitle:
                "Co czeka Twoje dziecko na lekcjach?<br>✅ Odkryje cyfrową kreatywność: animację, ilustrację, modelowanie 3D, design<br> ✅ Stworzy swoje pierwsze projekty (kolaż, stronę internetową, wizualizację 3D całego świata i animację do przyszłych kreskówek, gier itp.)<br> ✅ Pozna przydatne narzędzia do tworzenia cyfrowych dzieł sztuki",
            button: "Świetnie!",
        },
        4: {
            question:
                "Czy Twoje dziecko ma dostęp do laptopa lub komputera stacjonarnego do nauki?",
            answers: [
                "✅ Tak, ma własne urządzenie",
                "👥 Tak, ale dzieli je z innymi",
                {
                    answer: "🚫 Nie, nie ma stałego dostępu",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            question: "Co Twoje dziecko lubi tworzyć najbardziej?",
            answers: [
                "🎨 Rysować postacie i ilustracje",
                "🎬 Tworzyć animacje i krótkie filmy",
                "🖊️ Tworzyć plakaty, okładki i naklejki",
                "🏺 Tworzyć obiekty i światy 3D",
            ],
        },
        6: {
            question: "W jaki sposób Twoje dziecko woli pracować?",
            answers: [
                "🌈 Wymyślać pomysły i styl wizualny",
                "✏️ Pracować z kolorami i rysunkiem",
                "👥 Tworzyć projekty wspólnie z innymi dziećmi",
                "📐 Budować trójwymiarowe obiekty 3D",
            ],
        },
        7: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
                "Oferujemy zarówno zajęcia indywidualne, jak i grupowe, a także uwzględniamy wiek dzieci, aby jak najlepiej dostosować proces nauki do każdego dziecka.",
            button: "Zaczynamy!",
        },
        8: {
            question:
                "Jaki format nauki najbardziej odpowiada Twojemu dziecku?",
            answers: [
                "🚀 Próbować różnych rodzajów kreatywności",
                "🎨 Uczyć się designu, rysunku i animacji",
                "🧁 Uczyć się poprzez zajęcia kreatywne",
                "🎮 Zgłębiać 3D i bardziej zaawansowane oprogramowanie",
            ],
        },
        9: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/pl_personalized_quiz_fwd_r1_desk.png",
                "/welcome/pl_personalized_quiz_fwd_r2_desk.png",
                "/welcome/pl_personalized_quiz_fwd_r3_desk.png",
            ],
            sliderImagesMobile: [
                "/welcome/pl_personalized_quiz_fwd_r1_mob.png",
                "/welcome/pl_personalized_quiz_fwd_r2_mob.png",
                "/welcome/pl_personalized_quiz_fwd_r3_mob.png",
            ],
            duration: 5000,
            textLoader: "Analizujemy Twoje odpowiedzi, aby znaleźć najlepszy kurs...",
            titleLoader: "Analizujemy Twoje odpowiedzi, aby wybrać idealny kurs i nauczyciela",
            subtitleLoader: "⭐ 4,8 / 5 — na podstawie ponad 50 000 opinii",
        },
        10: {
            dynamicTypeInfo: [
                {
                    condition: [
                        {
                            step: 5,
                            answer: "🏺 Tworzyć obiekty i światy 3D",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/pl_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Wejdź do świata 3D | Kodland",
                        subtitle:
                            "Naucz się tworzyć obiekty i trójwymiarowe światy za pomocą profesjonalnych narzędzi i przenieś swoją kreatywność poza ekran.",
                        button: "👉 Zapisz się teraz",
                    },
                },
                {
                    condition: [
                        {
                            step: 6,
                            answer: "📐 Budować trójwymiarowe obiekty 3D",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/pl_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Wejdź do świata 3D | Kodland",
                        subtitle:
                            "Naucz się tworzyć obiekty i trójwymiarowe światy za pomocą profesjonalnych narzędzi i przenieś swoją kreatywność poza ekran.",
                        button: "👉 Zapisz się teraz",
                    },
                },
                {
                    condition: [
                        {
                            step: 8,
                            answer: "🎮 Zgłębiać 3D i bardziej zaawansowane oprogramowanie",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/pl_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Wejdź do świata 3D | Kodland",
                        subtitle:
                            "Naucz się tworzyć obiekty i trójwymiarowe światy za pomocą profesjonalnych narzędzi i przenieś swoją kreatywność poza ekran.",
                        button: "👉 Zapisz się teraz",
                    },
                },
                {
                    default: true,
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/pl_personalized_quiz_fwd_final_creativity.png",
                        title: "🧩 Przenieś kreatywność na wyższy poziom | Kodland",
                        subtitle:
                            "Design, ilustracja i animacja w jednym kursie — aby zamieniać pomysły w wyjątkowe projekty cyfrowe.",
                        button: "👉 Zapisz się teraz",
                    },
                },
            ],
        },
        11: {
            title: "Uzupełnij dane kontaktowe, aby uzyskać dostęp do darmowego kursu",
            type: "one-page-contacts",
            subtitle: "",
            button: "Prawie skończone 🔥",
        },
        12: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        13: {
            title: "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
            button: "Co jeszcze?",
         },
        14: {
            title:
                "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
            button: "Co jeszcze?",
        },
        15: {
            title: "Lekcja odbędzie się na naszej platformie 💻",
            typeInfo: "classroom",
            subtitle:
              "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
            button: "Rozumiem ✅",
        },
    },
};
